import { App } from 'antd';
import React from 'react';
import { setAntdAppApis } from '@/utils/antdAppApi';

const AntdAppBridge: React.FC = () => {
  const app = App.useApp();

  React.useEffect(() => {
    setAntdAppApis(app);
  }, [app]);

  return null;
};

export default AntdAppBridge;
